module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/logo_01-b83e3d2a9920b8a31fd3683859390de2.png";